import React from 'react';
import {
  Col,
  Grid,
  Row,
  ControlLabel,
} from 'react-bootstrap';

import PropTypes from 'prop-types';

import TabbedTimesheetApprovals from './TabbedTimesheetApprovals';
import TimesheetPanelEnhanced from './TimesheetPanelEnhanced';
import SupervisorInput from '../../fields/SupervisorInput';

const propTypes = {
  /* eslint-disable react/forbid-prop-types */
  currentlyLoggedInUser: PropTypes.object.isRequired,
  currentSupervisorId: PropTypes.number.isRequired,
  dispatchSelectSupervisor: PropTypes.func.isRequired,
  currentPayPeriod: PropTypes.object.isRequired,
  isCorpAdmin: PropTypes.bool.isRequired,
  /* eslint-enable react/forbid-prop-types */
};

const TimesheetApprovalsContainer = (props) => {
  const {
    currentPayPeriod,
    currentlyLoggedInUser,
    currentSupervisorId,
    dispatchSelectSupervisor,
    isCorpAdmin,
  } = props;
  const startDate = currentPayPeriod.start_date.display;
  const endDate = currentPayPeriod.end_date.display;

  return (
    <Grid fluid>
      <Row>
        <Col md={8}>
          <h2>Timesheet Approvals: {startDate} - {endDate}</h2>
          <br />
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          <hr />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <ControlLabel className="pull-left">Supervisor Name:</ControlLabel>
          <SupervisorInput
            currentUser={currentlyLoggedInUser}
            selectedSupervisorId={currentSupervisorId}
            onSelectSupervisor={(e) => { return dispatchSelectSupervisor(e); }}
            showAllSupervisors={isCorpAdmin}
          />
          <br />
          <TabbedTimesheetApprovals />
        </Col>
        <Col md={9}>
          <TimesheetPanelEnhanced />
        </Col>
      </Row>
    </Grid>
  );
};

TimesheetApprovalsContainer.propTypes = propTypes;

export default TimesheetApprovalsContainer;
